











































































































































































































import Vue from 'vue'
import VNumeric from './components/VNumeric/VNumeric'

export default Vue.extend({
  name: 'App',

  components: {
    VNumeric
  },

  data: () => ({
    label: 'My label',
    hint: 'My hint',
    calcNoTabindex: false,
    clearable: false,
    placeholder: 'type your number here',
    dark: false,
    fab: false,
    openKey: 'Enter',
    outlined: true,
    rounded: false,
    text: false,
    numPrecision: 2,
    useGrouping: true,
    min: -10000,
    max: 25000,
    prefix: '$',
    precision: 2,
    locale: 'en-US',
    locales: ['en-US', 'ru-RU', 'zh-ZH'],
    readonly: false,
    value: 0,
    useCalculator: true,
    calcStyle: {
      fab: false,
      outlined: false,
      rounded: false,
      text: false,
      tile: false,
      large: false,
      small: false
    }
  })
})
